<template>
  <section id="QA">
    <div class="row">
      <div class="title col-12 d-flex align-items-center justify-content-start ml-auto">
        <h1 class="h5">常見問題</h1>
      </div>
      <div class="col-12 mt-50">
        <div class="accordion">
          <div class="card" v-for="(items, index) in list" :key="index">
            <div
              class="card-header"
              :class="{active: show.indexOf(`${index}`)>=0}"
              @click="show!==index ? show = index : show = '' "
            >
              <h6 class="mb-0 px-10">{{getTitle(index)}}</h6>
            </div>
            <div class="collapse" :class="{show: show.indexOf(`${index}`)>=0}">
              <div class="card-body">
                <ul class="m-0 py-5" v-for="(item, key) in items" :key="key">
                  <li>{{item[0]}}</li>
                  <li v-if="list.transform || list.logout" v-html="item[1]"></li>
                  <li v-else>{{item[1]}}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'QA',
  metaInfo: {
    title: '常見問題 | ',
  },
  data() {
    return {
      list: {
        member: [
          ['申辦條件？', '年滿15歲並具備中華民國國籍者。'],
          ['如何申辦？', '下載APP註冊並以行動裝置收簡訊完成認證。'],
          [
            '申辦會員需要多少工作天？',
            '本會員使用APP會員系統，下載APP程式後，填寫會員基本資料後，並完成手機簡訊認證，系統將立即開通。',
          ],
          [
            '會員資料如何更改？',
            'APP內相關會員資料可自行更改，手機號碼變更則須至官網下載＂會員資料異動申請書＂填寫完成後同時附上身分證影本，放入信封郵寄至『115台北市南港區經貿一路170號12樓之2 漢齊科技』 將由專人協助更新。',
          ],
        ],
        usage: [
          ['如何計算累積、兌換消費點數？', '單筆消費滿$10元可累積0.03點，累積之點數可兌換優惠券or折抵現金。'],
          [
            '如何查詢餘額點數？',
            'APP會員中心可做查詢，也可撥打客服專線(02)8979-5558透過客服人員為您查詢。',
          ],
          [
            '點數使用是否有期限？',
            '每次所消費累積的點數將於該筆消費日的隔年年底到期。<br /> (亦即若於1/1消費累點，則點數最長可有兩年有效期)',
          ],
          ['優惠券是否有使用期限？', '依各行銷專案公告活動期間為主。'],
        ],
        transform: [
          ['點數是否可以轉移給他人？', '可以，可於手機APP&官網會員中心做轉移。'],
          ['點數轉移是否需要手續費？', '點數轉移免收取手續費。'],
          ['點數轉移是否限制轉移點數的數量？', '轉移點數最少轉移1點，最多則無限制。'],
          ['點數轉移後有效期如何計算？', '點數移轉後有效期仍以原點數交易日期為準。'],
          [
            '如何查詢點數轉移紀錄？',
            '可透過行動裝置APP及官網查詢，也可撥打客服專線(02)8979-5558透過客服人員為您查詢。',
          ],
          [
            '點數轉移失敗原因',
            `點數移轉可能因下列因素無法完成移轉
          <ol>
              <li>帳戶點數不足。</li>
              <li>給予方或受讓方沒有完成會員開通驗證。</li>
              <li>雙方在無網路環境下使用轉移點數功能。</li>
            </ol>         
          `,
          ],
        ],
        register: [
          [
            '會員消費點數如何登錄？是否能夠補登點數，需要回現場嗎？是否有天數限制？',
            '消費當下須具備會員資格，始能累積點數；如當下無出示行動裝置出式條碼供認證，消費後概不接受補登。<br />(補登服務目前尚未開放，補登機制未來將依各特店需求提供累點補登服務)',
          ],
        ],
        APP: [
          [
            '沒有收到會員手機驗證，該怎麼處理呢？',
            '確認填寫手機號碼無誤後，等待三分鐘後重新發送，若仍無法驗證，煩請與電信公司確認是否申辦阻擋企業/廣告簡訊功能。',
          ],
          [
            '沒有網路可以使用會員APP嗎？',
            'PP使用累兌點及相關功能，皆須使用行動裝置並在網路環境下使用。若在無網路環境中使用APP，將導致APP帳戶登出，並在恢復網路訊號後始可重新登入會員帳戶。 ',
          ],
        ],
        logout: [
          [
            '如何退出會員並終止相關權益？',
            `會員若要終止服務，需至下載
            <a href="https://drive.google.com/file/d/1-D8i2vghxKnwgpgifF35xi1fwY4zas4c/view?usp=sharing" target="_blank">
            「會員資料異動申請書」</a>
            填寫完成並同時附上身分證影本，放入信封郵寄至『115台北市南港區經貿一路170號12樓之2 漢齊科技』將由專人協助確認並終止服務。`,
          ],
        ],
      },
      show: 'member',
    };
  },
  methods: {
    getTitle(key) {
      switch (key) {
        case 'member':
          return '會員申辦';
        case 'usage':
          return '點數使用';
        case 'transform':
          return '點數轉移';
        case 'register':
          return '消費後點數補登錄';
        case 'APP':
          return 'APP認證&相關使用';
        case 'logout':
          return '會員退出';
        default:
          return '常見問題';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#QA {
  overflow: hidden;
  padding: 20px 0 100px;
  .title {
    border-bottom: 2px solid $primary-light;
  }
  .card-header {
    transition: 0.3s ease-out;
    cursor: pointer;
    color: $secondary-light;
    &:hover,
    &.active {
      background: $sub-primary;
      color: black;
    }
  }
  .card-body {
    ul {
      list-style: none;
      li {
        margin: 10px 0;
        position: relative;
        padding-left: 35px;
        &::before {
          position: absolute;
          color: $primary;
          font-weight: 700;
          display: inline-block;
          left: 0;
          top: 2px;
          text-align: center;
          line-height: 25px;
          border-radius: 50%;
        }
      }
      li:first-of-type {
        &::before {
          content: 'Q︰';
        }
      }
      li:last-of-type {
        &::before {
          content: 'A︰';
        }
      }
    }
  }
}
</style>
